import produce from 'immer';

import {
  FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_FAILURE,
  FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_SUCCESS,
  FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_FAILURE,
  FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_SUCCESS,
  FORCED_ABATEMENT_ACTIVITY_CREATE_FAILURE,
  FORCED_ABATEMENT_ACTIVITY_EDIT_FAILURE,
  FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_FAILURE,
  FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_SUCCESS,
  FORCED_ABATEMENT_ACTIVITY_EDIT_SUCCESS,
  FORCED_ABATEMENT_ACTIVITY_FETCH_FAILURE,
  FORCED_ABATEMENT_ACTIVITY_FETCH_SUCCESS,
  FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_FAILURE,
  FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_SUCCESS,
} from '@actions/forcedAbatementActivity';

const initialState: IForcedAbatementActivityStore = {
  associatedNotices: null,
  currentForcedAbatementActivity: null,
  forcedAbatementActivities: null,
  error: null,
};

export default (state: IForcedAbatementActivityStore = initialState, action: any) =>
  produce(state, (draftState: IForcedAbatementActivityStore) => {
    switch (action.type) {
      case FORCED_ABATEMENT_ACTIVITY_EDIT_SUCCESS:
      case FORCED_ABATEMENT_ACTIVITY_FETCH_SUCCESS:
        draftState.currentForcedAbatementActivity = action.response;
        draftState.error = null;

        return;

      case FORCED_ABATEMENT_ACTIVITY_EDIT_FAILURE:
      case FORCED_ABATEMENT_ACTIVITY_CREATE_FAILURE:
      case FORCED_ABATEMENT_ACTIVITY_FETCH_FAILURE:
        draftState.currentForcedAbatementActivity = null;
        draftState.error = action.error;

        return;

      case FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_FAILURE:
      case FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_FAILURE:
        draftState.forcedAbatementActivities = null;
        draftState.error = action.error;

        return;

      case FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_SUCCESS:
      case FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_SUCCESS:
        draftState.forcedAbatementActivities = action.response;
        draftState.error = null;

        return;

      case FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_SUCCESS:
      case FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_SUCCESS:
        draftState.associatedNotices = action.response;
        draftState.error = null;

        return;

      case FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_FAILURE:
      case FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_FAILURE:
        draftState.error = action.error;
        draftState.associatedNotices = null;

        return;
    }
  });
